module.exports = __webpack_public_path__ + "media/images/logos/logo-mindset-white-2e64a6d29b8272619cce54abe9c5a709.svg";